var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('PageTitle',[_vm._v("Opret nyt præparat")]),_c('section',[_c('CreatePreparation',{attrs:{"default-item":_vm.defaultItem},on:{"created":_vm.onCreated}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }